/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRestorePasswordConfirmDto } from '../../models/backend-restore-password-confirm-dto';
import { BackendRestorePasswordConfirmRequestDto } from '../../models/backend-restore-password-confirm-request-dto';

export interface AccountMeRestorePasswordConfirmCreate$Params {
  body: BackendRestorePasswordConfirmRequestDto;
}

export function accountMeRestorePasswordConfirmCreate(
  http: HttpClient,
  rootUrl: string,
  params: AccountMeRestorePasswordConfirmCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRestorePasswordConfirmDto>> {
  const rb = new RequestBuilder(rootUrl, accountMeRestorePasswordConfirmCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRestorePasswordConfirmDto>;
    }),
  );
}

accountMeRestorePasswordConfirmCreate.PATH = '/api/account/me/restore_password/confirm/';
